import axios from "axios";
import React, { useState, useEffect, useRef } from 'react';
import { useParams, Link } from 'react-router-dom';
import Swal from 'sweetalert2';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';

import { baseUrl, baseimgUrl, userLocation, ipAddress, userName } from '../Univ.js';

function InvFilesView(props) {
  const { id } = useParams();
  const [invData, setInvData] = useState([]);
  const [docs, setDocs] = useState([]);
  const [temp, setTemp] = useState([]);
  const [selectedTemplate, setSelectedTemplate] = useState('');
  const [remarks, setRemarks] = useState(''); // Manage the remarks state
  const quillRef = useRef(null);
  const [hospData, setHospData] = useState([]);

  useEffect(() => {
    axios.get(baseUrl + 'inv-imgs-view/' + id + '/')
      .then(response => {
        setInvData([response.data]);
        setRemarks(response.data.remarks || ''); // Initialize remarks state
      })
      .catch(error => console.log("API Error:", error));
  }, [id]);
    useEffect(() => {

            try {
              axios.get(baseUrl + "view-hospital/" + userLocation + "/").then(function (response) {
                setHospData(response.data);
              });
            } catch (error) {
              console.log(error);
            }
      },[]);

  useEffect(() => {
    const base = baseimgUrl + "media/";
    if (invData.length > 0) {
      const invtFilesString = invData[0].invt_files;
      const urlsArray = invtFilesString.split(',');
      const documents = urlsArray.map(url => ({
        uri: base + url.trim(),
      }));
      setDocs(documents);
    }
  }, [invData]);

  useEffect(() => {
    fetchTempData();
  }, []);

  const fetchTempData = () => {
    axios.get(`${baseUrl}template-create/`)
      .then(response => setTemp(response.data))
      .catch(error => console.log(error));
  };

  const handleTemplateChange = (event) => {
    const selectedTemplateId = event.target.value;
    setSelectedTemplate(selectedTemplateId);

    axios.get(baseUrl + "edit-template/" + selectedTemplateId + "/")
      .then(response => {
        const templateContent = response.data.template || '';
        setRemarks(templateContent); // Update remarks state with selected template content
      })
      .catch(error => console.log(error));
  };

  const getTestNameById = () => {
    if (invData.length > 0) {
      const invItestId = invData[0].itest_id.trim();
      const testIds = invData[0].inv.itest_id.split(',').map(id => id.trim());
      const testNames = invData[0].inv.inv_test.split(',').map(name => name.trim());

      const index = testIds.findIndex(testId => testId === invItestId);
      if (index !== -1) {
        return testNames[index];
      } else {
        return 'Test name not found';
      }
    }
    return 'Loading...';
  };

  const handlePrint = () => {
        const printContents = document.getElementById('invoice-print').innerHTML;
        const originalContents = document.body.innerHTML;
        document.body.innerHTML = printContents;
        window.print();
        setTimeout(() => {
            window.location.reload();
        }, 1000);
        document.body.innerHTML = originalContents;
     };
  return (
    <section>
    <div id="invoice-print">
      {invData.map((row, index) => (
        <div key={index}>
          <table style={{ border: '2px solid #ccc', width: '100%', margin: '20px 0', borderRadius: '5px', borderCollapse: 'collapse' }}>
            <thead>
              <tr>
                    {hospData.map((hospital) => (
                      <React.Fragment key={hospital.id}>
                        <td align="center" colSpan="3" style={{
                          padding: '4px', borderRadius: '25px', color: '#000'}}>
                          <p align="center">
                            <strong>{hospital.hospital}</strong><br />
                            Address&nbsp;: &nbsp;{hospital.address}&nbsp;&nbsp;&nbsp;-&nbsp;
                            <br />Phone : {hospital.mobile} &nbsp; Email : {hospital.email} &nbsp; <br />
                            Web : {hospital.website}
                          </p>
                        </td>
                      </React.Fragment>
                    ))}
                  </tr>
              <tr style={{ backgroundColor: '#F2F2F2', borderBottom: '2px solid #ccc' }}>
                <th style={{ padding: '10px', textAlign: 'left' }}>
                  PID: {row.pat.pat_id}
                </th>
                <th style={{ padding: '10px', textAlign: 'left' }}>
                  Patient: {row.pat.patient}
                </th>
                 <th style={{ padding: '10px', textAlign: 'left' }}>
                  Test Name: {getTestNameById()}
                </th>
              </tr>
            </thead>
          </table>
        </div>
      ))}
      <div className="card card-body mt-3">
        <div className="table-responsive">
          <table className="table table-bordered table-hover" style={{ borderColor: '#333', marginTop: '20px' }}>
            <thead>
              <tr style={{ backgroundColor: '#F5F5F5', fontWeight: 'bold' }}>
                <th style={{ width: '40%' }}>Files</th>
                <th style={{ width: '80%' }}>Reports</th>
                </tr>
            </thead>
            <tbody>
              {invData.length > 0 ? (
                invData.map((row, index) => (
                  <tr key={index}>

                    <td style={{ textAlign: 'center' }}>
                      {row.invt_files.split(',').map((file, fileIndex) => (
                        <div key={fileIndex} className="file-viewer-item" style={{ marginBottom: '10px' }}>
                          <a href={`${baseimgUrl}media/${file.trim()}`} target="_blank" rel="noopener noreferrer">
                            <img
                              src={`${baseimgUrl}media/${file.trim()}`}
                              alt={`Thumbnail ${fileIndex}`}
                              style={{ maxWidth: '300px', maxHeight: '300px', objectFit: 'cover' }}
                            />
                          </a>
                        </div>
                      ))}
                    </td>
                    <td style={{ textAlign: 'center' }}>
                      <div dangerouslySetInnerHTML={{ __html: row.remarks || '' }} />
                    </td>

                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="4" style={{ textAlign: 'center' }}>No data available</td>
                </tr>
              )}
            </tbody>

          </table>
        </div>
      </div>
      </div>
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
              <button style={{ padding: '5px 20px', borderRadius: '10px', backgroundColor: '#007bff', color: '#fff' }}
              onClick={handlePrint}
              >
               Print
              </button>
            </div>

    </section>
  );
}

export default InvFilesView;
